import { Injectable } from '@angular/core';
//import { AngularFire, FirebaseListObservable } from 'angularfire2';
import * as firebase from 'firebase';
import { Router }  from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
//import * as AWS from 'aws-sdk';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { Member } from './member';
declare var AWS:any;
@Injectable()

export class MemberService {
	//EBURL = "http://localhost:3000/";
	EBURL = "https://cef-server.herokuapp.com/";
	modalDismiss = 2000;
	public s3;
	private subject = new Subject<any>();
	private avatarSrc = new Subject<any>();

	journeyPerSeries = [8,16,26];
	totalJourneySeries = 3;
	joyPerSeries = 30;
	totalJoySeries = 12;


	retTaskAwards = {
		progress:{
			newMember:[],
			journey:{},
			joy:{}
		},
		awards:{
			login:0,
			journey:0,
			joy:0,
			newMember:false
		}
	}

	websys = "websys@lovekid.hk"
	defaultReciever = "noomochau@yahoo.com"

	//memberProfile = new Member();
	constructor(private router: Router) {
		AWS.config.update({ accessKeyId: 'AKIAJL6OYHUFDRAFGYGQ', secretAccessKey: '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' });
		AWS.config.region = 'ap-southeast-1';
		this.s3 = new AWS.S3();
	}

	genCert(memberProfile, level){
		
		let W=2480, H=1754;
		if (level==1){
			createCanvas(1);
		} else if (level==2){
			createCanvas(2);
		} else if (level==3){
			createCanvas(3);
		} else if (level==4){
			createCanvas(4);
		}

		function createCanvas(lvl){
			let canv = document.createElement('canvas');
			canv.id = 'certCanvasLvl'+lvl;
			canv.style.display = "none";
			canv.height = H;
			canv.width = W;
			document.body.appendChild(canv);
			let ctx = canv.getContext("2d");
			let image = new Image();
			if (lvl <= 3) {
				image.src = "./assets/certLvl"+lvl+".jpg";
			} else if (lvl == 4){
				image.src = "./assets/certGrad.jpg";
			}
			
			image.onload = ()=>{
				ctx.drawImage(image, 0, 0, W, H);
				ctx.font = "120px SimHei";
				ctx.textAlign="center";
				// 800 for grad cert
				if (lvl <= 3) {
					ctx.fillText(memberProfile.name,1350,510);
				} else if (lvl == 4){
					ctx.fillText(memberProfile.name,1350,800);
				}
				if (memberProfile.tutorName) {
					ctx.fillText(memberProfile.tutorName,2100,1460);
				}
				let today = new Date();
				ctx.fillText(today.getFullYear().toString(), 1360,1660);
				ctx.fillText((today.getMonth() + 1).toString(), 1780,1660);
				ctx.fillText(today.getDate().toString(), 2170,1660);
				let downloadLink = document.getElementById('downloadCertLvl'+lvl);
				let downloadImg = canv.toDataURL("image/jpeg").replace("image/png", "image/octet-stream");
				downloadLink.setAttribute("href", downloadImg);
			}
		}
	}

	sendApproveMail(senderEmail, recieverEmail, recieverName, nextTime){
		if (!senderEmail || !recieverEmail) return
		AWS.config.region = 'us-west-2';
		
		// Create sendEmail params 
		var params = {
			Destination: {
				ToAddresses: [
					recieverEmail,
				]
			},
			Message: { /* required */
			Body: { /* required */
				Html: {
					Charset: "UTF-8",
					Data: recieverName+"同學您好：<br><br>您已獲批準於"+nextTime+"之後進行下一課栽培歷程。<br><br>請按以下步驟：<br>1. 登入網站 <a href='https://app.lovekid.hk/login'>https://app.lovekid.hk/login</a><br>2. 點擊“栽培歷程”<br>3. 選擇第其中一輯<br>4. 選擇最新一課<br><br>Lovekid兒童天地網站<br>**此電郵是由電腦系統自動發送的，請勿回覆此電郵。如欲與我們聯絡，請電郵it@cef.org.hk**"
				},
				Text: {
					Charset: "UTF-8",
					Data: recieverName+"同學您好： 您已獲批準於"+nextTime+"之後進行下一課栽培歷程。 請按以下步驟： 1. 登入網站 <a href='https://app.lovekid.hk/login'>https://app.lovekid.hk/login</a> 2. 點擊“栽培歷程” 3. 選擇第其中一輯 4. 選擇最新一課 Lovekid兒童天地網站 **此電郵是由電腦系統自動發送的，請勿回覆此電郵。如欲與我們聯絡，請電郵it@cef.org.hk**"
				}
			},
			Subject: {
				Charset: 'UTF-8',
				Data: ' [Lovekid.hk] 下一課 - 栽培歷程'
			}
			},
			Source: senderEmail, 
			ReplyToAddresses: [
				senderEmail,
			],
		};       
		
		// Create the promise and SES service object
		var sendPromise = new AWS.SES({apiVersion: '2010-12-01'}).sendEmail(params).promise();
		
		// Handle promise's fulfilled/rejected states
		sendPromise.then(
			function(data) {
				console.log(data.MessageId);
			}).catch(
			function(err) {
				console.error(err, err.stack);
			});
	}

	sendMail(){
		AWS.config.region = 'us-west-2';
		var ses = new AWS.SES();

		var msgTitle = 'test'
		var boundary = ''
		var mailBoundary = "_=sesEmail=_" + boundary;
		var msgContent = "<h1>test</h1>"

		var rawMsg = 'From: "no-reply" <websys@lovekid.hk>\n';
		rawMsg += 'To: <'+this.defaultReciever+'>\n';
		rawMsg += 'Reply-To: websys@lovekid.hk\n';
		rawMsg += 'Date: '+new Date().toString()+'\n';
		rawMsg += 'Subject: '+msgTitle+'\n';
		rawMsg += 'Message-ID: <'+boundary+'@us-west-2.amazonses.com>\n';
		rawMsg += 'MIME-Version: 1.0\n';

		//rawMsg += 'Content-Type: multipart/alternative;\n';
		//rawMsg += '--'+mailBoundary+'\n';
		//rawMsg += '--'+mailBoundary+'\n';
		rawMsg += 'Content-Type: text/html; charset="UTF-8"\n';
		rawMsg += 'Content-Transfer-Encoding: quoted-printable\n';
		rawMsg += '\n';
		rawMsg += msgContent;
		rawMsg += '\n';
		//rawMsg += '--'+mailBoundary+'--\n';

		var data = {
			RawMessage: {Data: rawMsg},
			Destinations: [this.defaultReciever]
		};
		
		ses.sendRawEmail(data, function(err, rtnData) {
			if (err) {
				console.log(err, err.stack); 
			} else {
				console.log(rtnData);
			}
		});
		
	}

	logAct(type:string, uid:string, level:number, params = ""){
		if (level>=4){
			switch(type) { 
				case 'viewWebGuide': { 
					this._logViewWebGuide(uid); 
					break; 
				} 
				case 'addAvatar': { 
					this._logAddAvatar(uid); 
					break; 
				} 
				case 'updateProfile': { 
					this._logUpdateProfile(uid); 
					break; 
				} 
				case 'startFarm': { 
					this._logStartFarm(uid); 
					break; 
				} 
				case 'viewSpritJoyGuide': { 
					this._logViewSpritJoyGuide(uid);
					break; 
				} 
				case 'login': { 
					this._logLogin(uid); 
					break; 
				} 
				case 'listenStory': { 
					this._logListenStory(uid);  
					break; 
				} 
				case 'readSpritJoy': { 
					this._logReadSpritJoy(uid, params);  
					break; 
				} 
				case 'readJourney': { 
					this._logReadJourney(uid, params);  
					break;  
				} 
				case 'resultFarm': { 
					this._logResultFarm(uid); 
					break; 
				} 
				case 'leaveMsg': { 
					this._logLeaveMsg(uid, params);  
					break; 
				} 
				case 'seasonTask': { 
					this._logSeasonTask(uid, params);  
					break; 
				}
			}
		}
	}

	getAwards(memberProfile:any): Observable<any>{
		var db = firebase.database();
		db.ref('journeyRecords/'+memberProfile.Uid).once('value').then(
			(journeyRec:any) => {
				db.ref('joyRecords/'+memberProfile.Uid).once('value').then(
					(joyRec:any) => {
						db.ref('awards/'+memberProfile.Uid).once('value').then(
							(awards:any) => {
								let journeySeries = 1;
								let joySeries = 1;
								let joySerieLength = 30;
								let journeyProgress = 0;
								let journeySerieLength = 8;
								if (journeyRec.val()) journeyProgress = journeyRec.val().length - 1;
								//journeyProgress = 16
								let joyProgress = 0;
								if (joyRec.val()) joyProgress = joyRec.val().length - 1;
								if (journeyProgress > this.journeyPerSeries[0] && journeyProgress <= this.journeyPerSeries[1]){
									journeySeries = 2;
									journeySerieLength = this.journeyPerSeries[1]-this.journeyPerSeries[0];
								} else if (journeyProgress > this.journeyPerSeries[1] && journeyProgress <= this.journeyPerSeries[2]){
									journeySeries = 3;
									journeySerieLength = this.journeyPerSeries[2]-this.journeyPerSeries[1];
								}
								if (joyProgress > 30) joySeries = Math.floor(joyProgress/this.joyPerSeries);
								
								this.retTaskAwards.progress.journey = {
									totalSerie: this.totalJourneySeries,
									serie:journeySeries,
									progress:journeyProgress,
									serieLength:journeySerieLength
								}
								this.retTaskAwards.progress.joy = {
									totalSerie: this.totalJoySeries,
									serie:joySeries,
									progress:joyProgress,
									serieLength:joySerieLength
								}
								
								let updatedAwards = awards.val();
								// check new member progress
								if (updatedAwards){
									if (updatedAwards.login) {
										this.retTaskAwards.progress.newMember.push('login');
										this.retTaskAwards.awards.login = updatedAwards.login.length-1;
									}
									if (updatedAwards.updateProfile) this.retTaskAwards.progress.newMember.push('updateProfile');
									if (updatedAwards.viewWebGuide) this.retTaskAwards.progress.newMember.push('viewWebGuide');
									if (updatedAwards.viewSpritJoyGuide) this.retTaskAwards.progress.newMember.push('viewSpritJoyGuide');
									if (this.retTaskAwards.progress.newMember.indexOf('login') >=0 && this.retTaskAwards.progress.newMember.indexOf('updateProfile') >= 0 && this.retTaskAwards.progress.newMember.indexOf('viewWebGuide') >= 0 && this.retTaskAwards.progress.newMember.indexOf('viewSpritJoyGuide') >= 0) this.retTaskAwards.awards.newMember = true;
									
									//check other awards
									
									if (journeyProgress >= this.journeyPerSeries[0]){
										this.retTaskAwards.awards.journey = 1;
										this.genCert(memberProfile, 1)
									}
									if (journeyProgress >= this.journeyPerSeries[1]){
										this.retTaskAwards.awards.journey = 2;
										this.genCert(memberProfile, 2)
									}
									if (journeyProgress >= this.journeyPerSeries[2]){
										this.retTaskAwards.awards.journey = 3;
										this.genCert(memberProfile, 3)
										this.genCert(memberProfile, 4)
									}
									if (joySeries > 1) this.retTaskAwards.awards.joy = joySeries - 1;
									if (joyProgress == (this.totalJoySeries * this.joyPerSeries)) this.retTaskAwards.awards.joy = 12;
								}
								
								
								this.subject.next(this.retTaskAwards);
							}
						)
					}
				)
			}
		)
		return this.subject.asObservable();
		
	}

	avatar(): Observable<any>{
		return this.avatarSrc.asObservable();
	}

	updateAvatar(avatar){
		this.avatarSrc.next(avatar);
	}

	_logUpdateProfile(uid:string){
		//profile.component.ts line 69
		var dObj = new Date();
		let db = firebase.database();
		db.ref('actRecs/' + uid + '/updateProfile/').set(dObj.toString());
		db.ref('awards/'+uid+'/updateProfile').once('value').then(
			 (snapshot:any) => {
				 if (!snapshot.val()){
					db.ref('awards/' + uid + '/updateProfile').set(dObj.toString());
				 }
			 }
		)
	}

	_logLogin(uid:string){
		//login.component.ts line 107
		let db = firebase.database();
		var dObj = new Date();
		var y = dObj.getFullYear();
		var m = dObj.getMonth()<10?'0'+dObj.getMonth():dObj.getMonth();
		var d = dObj.getDate()<10?'0'+dObj.getDate():dObj.getDate();
		var h = dObj.getHours();
		var min = dObj.getMinutes();
		var s = dObj.getSeconds();
		var today = y+'-'+m+'-'+d;
		db.ref('actRecs/' + uid + '/login/'+today).set(h+':'+min+':'+s).then(
			(ret:any)=>{
				db.ref('actRecs/'+uid+'/login').once('value').then(
					(snapshot:any) => {
						if (snapshot.val()){
							var completedLevel = Math.floor(Object.keys(snapshot.val()).length/30);
							if (completedLevel>=1&&completedLevel<=5){
								db.ref('awards/'+uid+'/login/'+completedLevel).once('value').then(
									(awards:any) => {
										if (!awards.val()){
											db.ref('awards/' + uid + '/login/'+completedLevel).set(dObj.toString());
										}
									}
								)
							}
						}
					}
				)
			}
		)
	}

	_logAddAvatar(uid:string){
		var dObj = new Date();
		let db = firebase.database();
		db.ref('actRecs/' + uid + '/addAvatar').set(dObj.toString());
		db.ref('awards/'+uid+'/addAvatar').once('value').then(
			 (snapshot:any) => {
				 if (!snapshot.val()){
					db.ref('awards/' + uid + '/addAvatar').set(dObj.toString());
				 }
			 }
		)
	}

	_logReadJourney(uid:string, day:string){
		//journey-chapter.component.ts line 44
		let db = firebase.database();
		var dObj = new Date();
		db.ref('actRecs/' + uid + '/readJourney/'+day).set(dObj.toString()).then(
			(ret:any)=>{
				db.ref('journeyRecords/'+uid).once('value').then(
					(snapshot:any)=>{
						if (snapshot.val()){
							var completedLevel=snapshot.val().length-1;
							var grantLevel = Math.floor(completedLevel/9);
							if (grantLevel==1||grantLevel==2){
								db.ref('awards/'+uid+'/readJourney/'+grantLevel).once('value').then(
									(awards:any) => {
										if (!awards.val()){
											db.ref('awards/' + uid + '/readJourney/'+grantLevel).set(dObj.toString());
										}
									}
								)
							} else if (completedLevel==26){
								db.ref('awards/'+uid+'/readJourney/3').once('value').then(
									(awards:any) => {
										if (!awards.val()){
											db.ref('awards/' + uid + '/readJourney/3').set(dObj.toString());
										}
									}
								)
							}
						}
					}
				)
			}
		)
	}

	_logReadSpritJoy(uid:string, day:string){
		//spritjoy-day.component.ts line 48
		let db = firebase.database();
		var dObj = new Date();
		db.ref('actRecs/' + uid + '/readSpritJoy/'+day).set(dObj.toString()).then(
			(ret:any)=>{
				db.ref('actRecs/' + uid + '/readSpritJoy/').once('value').then(
					(snapshot:any)=>{
						if (snapshot.val()){
							var completedDay=snapshot.val().length-1;
							var grantLevel = Math.floor(completedDay/30);
							if (grantLevel>=1&&grantLevel<=12){
								db.ref('awards/'+uid+'/readSpritJoy/'+grantLevel).once('value').then(
									(awards:any) => {
										if (!awards.val()){
											db.ref('awards/' + uid + '/readSpritJoy/'+grantLevel).set(dObj.toString());
										}
									}
								)
							}
						}
					}
				)
			}
		)
	}

	_logSeasonTask(uid:string, taskName:string){
		let db = firebase.database();
		var dObj = new Date();
		db.ref('actRecs/' + uid + '/seasonTask/'+taskName).set(dObj.toString());
	}

	_logLeaveMsg(uid:string, msgId:string){
		let db = firebase.database();
		var dObj = new Date();
		db.ref('actRecs/' + uid + '/leaveMsg/'+msgId).set(dObj.toString());
	}

	_logResultFarm(uid:string){
		
	}

	_logListenStory(uid:string){
		
	}

	_logStartFarm(uid:string){
		let db = firebase.database();
		db.ref('actRecs/' + uid + '/startFarm/').set('true');
	}

	_logViewWebGuide(uid:string){
		let db = firebase.database();
		db.ref('actRecs/' + uid + '/viewWebGuide/').set('true');
	}

	_logViewSpritJoyGuide(uid:string){
		let db = firebase.database();
		db.ref('actRecs/' + uid + '/viewSpritJoyGuide/').set('true');
	}

}


// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/member/member.service.ts